import { GetterTree } from "vuex";
import { State } from '@/store/modules/synthetics/endpoints/endpoints.store';
const getters: GetterTree<State, State> = {
  getCurrentGroupId: (state) => {
    return state.currentGroupId;
  },
  getTotalEndpointForGroup: (state) => {
    return state.totalEndpointsForGroup
  },
  getCurrentEndpointId: (state) => {
    return state.currentEndpointId;
  },
  getFormData: state => {
    return state.formData;
  },
  getBasicInfoFormData: state => {
    return state.formData.basicInfoConfig;
  },
  getAuthDetails: state => {
    return state.formData.authConfig;
  },
  getRequestDetails: state => {
    return state.formData.requestConfig;
  },
  getAdditionalOptnDetails: state => {
    return state.formData.additionalOptions;
  },
  getAllMappedEndpointsDeleted: state => {
    return state.allMappedEndpointsDeleted;
  },
  getDispOnlyFillDetails: state => {
    return state.dispOnlyFillDetails;
  }
};

export default getters;
